import React, { createContext, useState, useCallback, useRef } from 'react';
import ConfirmModal from './index';

export const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, title: '', message: '' });
  const resolverRef = useRef(null);

  const confirm = useCallback(({ title = 'Confirm', message = 'Are you sure?' } = {}) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setState({ open: true, title, message });
    });
  }, []);

  const handleConfirm = () => {
    setState({ open: false, title: '', message: '' });
    resolverRef.current?.(true);
    resolverRef.current = null;
  };

  const handleCancel = () => {
    setState({ open: false, title: '', message: '' });
    resolverRef.current?.(false);
    resolverRef.current = null;
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state.open && (
        <ConfirmModal
          title={state.title}
          message={state.message}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </ConfirmContext.Provider>
  );
}
